// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paginationContainer_XlhuM {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    height: fit-content;
    max-width: fit-content;
  }
  @media (width<=768px) {
    .pagination_L1s2Z{
      margin-bottom: 10px; 
    }
  }
  

  .paginationNumbers_knmJU{
    display: flex;
    gap: 10px;
    align-items: center;
  }
 
  .active_LTkTj{
    background-color: var(--_10a37e6a-background);
  }



  `, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/PaginationTables/PaginationTables.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE;MACE,mBAAmB;IACrB;EACF;;;EAGA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,6CAA6C;EAC/C","sourcesContent":[".paginationContainer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    height: fit-content;\n    max-width: fit-content;\n  }\n  @media (width<=768px) {\n    .pagination{\n      margin-bottom: 10px; \n    }\n  }\n  \n\n  .paginationNumbers{\n    display: flex;\n    gap: 10px;\n    align-items: center;\n  }\n \n  .active{\n    background-color: var(--_10a37e6a-background);\n  }\n\n\n\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paginationContainer": `paginationContainer_XlhuM`,
	"pagination": `pagination_L1s2Z`,
	"paginationNumbers": `paginationNumbers_knmJU`,
	"active": `active_LTkTj`
};
export default ___CSS_LOADER_EXPORT___;
